import { render, staticRenderFns } from "./BattleStatistics.vue?vue&type=template&id=2201f7f2&scoped=true&"
import script from "./BattleStatistics.vue?vue&type=script&lang=js&"
export * from "./BattleStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BattleStatistics.vue?vue&type=style&index=0&id=2201f7f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201f7f2",
  null
  
)

export default component.exports